export default "__VITE_ASSET__BesXYjef__"